import React from "react";
import AccountSelector from "./AccountSelector";
import { usePermissions } from "../contexts/PermissionContext";
import { filterNavItems } from "../utils/permissionChecker";

export default function SideNav({
  open,
  onClose,
  items = [],
  activeKey,
  onSelect,
  user,
  adminItems = [],
  isAdmin = false,
}) {
  const { hasPermission } = usePermissions();
  const initials = String(user?.name || user?.userName || 'U').trim().charAt(0).toUpperCase();
  
  // Use the generic permission checker to filter navigation items
  const navList = isAdmin ? adminItems : filterNavItems(items, hasPermission);

  // Permanent sidebar on md+, drawer on mobile
  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`fixed inset-0 bg-black/30 z-40 md:hidden ${open ? '' : 'hidden'}`}
        onClick={onClose}
        aria-hidden={!open}
      />
      {/* Drawer / Sidebar */}
      <aside
        data-tour="side-nav"
        className={`fixed z-50 md:z-30 top-0 left-0 h-full w-72 bg-white border-r border-green-100 shadow-sm transform transition-transform duration-200 ease-out flex flex-col
        ${open ? 'translate-x-0 md:translate-x-0' : '-translate-x-full md:-translate-x-full'}`}
        style={{
          paddingTop: 'var(--tp-safe-area-top, 0px)',
          paddingBottom: 'var(--tp-safe-area-bottom, 0px)'
        }}
        aria-label="Side navigation"
      >
        {/* Profile section */}
        <div className="px-4 pt-4 pb-3 border-b border-green-100 bg-white">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-green-100 border border-green-200 text-green-700 font-semibold flex items-center justify-center shadow-sm">
              {initials}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-gray-800 truncate">{user?.name || user?.userName || 'User'}</div>
              <div className="text-[11px] text-gray-500 truncate">{isAdmin ? 'Admin' : 'Member'}</div>
            </div>
            </div>
            <button
              aria-label="Close sidebar"
              onClick={onClose}
              className="w-9 h-9 rounded-lg border border-green-200 text-green-700 hover:bg-green-50"
              title="Close"
            >
              ✕
            </button>
          </div>
        </div>
        
        {/* Account Selector - only show for non-admin users */}
        {!isAdmin && (
          <div className="px-4 py-3 border-b border-green-100 bg-gray-50">
            <AccountSelector />
          </div>
        )}
        
        {/* Nav items */}
        <nav className="flex-1 overflow-y-auto py-2">
          <ul className="px-2 space-y-1">
            {navList.map((it) => (
              <li key={it.key}>
                <button
                  className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors
                    ${activeKey === it.key ? 'bg-green-50 text-green-700 border border-green-200' : 'text-gray-700 hover:bg-green-50 hover:text-green-700'}`}
                  onClick={() => { onSelect?.(it.key); if (typeof window !== 'undefined' && window.innerWidth < 768) onClose?.(); }}
                >
                  <span className="text-lg">{it.icon}</span>
                  <span className="truncate" title={it.label || it.labelKey}>{it.label || it.labelKey}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
}


